// extracted by mini-css-extract-plugin
module.exports = {"component":"styles-module--component--1qDpc","heading":"styles-module--heading--1S8H8","active":"styles-module--active--1i4qP","logo":"styles-module--logo--3FWcA"};